<script lang="ts">
	interface Props {
		size?: number;
	}

	let { size = 24 }: Props = $props();
</script>

<!--
	The same mark as the browser tab (static/favicon.svg). Kept as markup rather than an
	<img> of that file so it takes the theme's colours — the favicon has to hard-code
	them, because a tab icon cannot read the app's tokens.
-->
<svg
	width={size}
	height={size}
	viewBox="0 0 32 32"
	role="img"
	aria-label="SLA Reports"
	class="logo"
>
	<rect width="32" height="32" rx="7" />
	<g fill="none" stroke-width="2.4" stroke-linecap="round">
		<path d="M9 21.5V15" />
		<path d="M16 21.5V9.5" />
		<path d="M23 21.5v-8" />
	</g>
</svg>

<style>
	.logo {
		flex: none;
		display: block;
	}

	rect {
		fill: var(--color-primary);
	}

	g {
		stroke: var(--color-primary-contrast);
	}
</style>
